<template>
    <div class="Adeletebe safe-distance-top">
        <div class="Adeletebe_top">
            <van-icon
                style="position: absolute; left: 10px"
                size="25"
                name="arrow-left"
                @click="to()"
            />
            <div class="my">机构</div>
            <div class="determine" @click="toInformation">确定</div>
        </div>
        <div class="Adeletebe_bottm">
            <van-cell-group inset style="height: 48px; margin: 0px 0px">
                <van-field
                    required
                    label="机构名称"
                    v-model="item.unitName"
                    placeholder="请输入机构名称"
                >
                    <template #button>
                        <van-button size="small" style="border: none"
                            >{{ item.unitName ? item.unitName.length : "0" }}/20</van-button
                        >
                    </template>
                </van-field>
            </van-cell-group>
            <van-cell-group>
                <van-field
                    v-model="item.job"
                    placeholder="请输入"
                    label="现任职位"
                    maxlength="20"
                    center
                />
            </van-cell-group>
            <van-cell-group>
                <van-field
                    name="picker"
                    label="选择省市"
                    :value="fieldValue"
                    is-link
                    readonly
                    clickable
                    placeholder="请选择"
                    @click="showPicker = true"
                />
                <van-popup v-model="showPicker" :round="true" closeable position="bottom">
                    <van-tabs v-model="country">
                        <van-tab title="中国" :name="0" title-class="tab-box">
                            <van-cascader
                                v-model="cascaderValue"
                                :show-header="false"
                                active-color="#4A79F1"
                                :options="options"
                                :field-names="fieldNames"
                                @change="onChange"
                                @finish="onFinish"
                            />
                        </van-tab>
                        <van-tab title="海外" :name="1" title-class="tab-box">
                            <van-cascader
                                v-model="cascaderValue"
                                :show-header="false"
                                active-color="#4A79F1"
                                :options="[{ name: '海外', code: 0 }]"
                                :field-names="fieldNames"
                                @finish="onFinish"
                            />
                        </van-tab>
                    </van-tabs>
                </van-popup>
            </van-cell-group>
            <van-cell-group>
                <van-field v-model="item.address" placeholder="请输入" label="详细地址">
                </van-field>
            </van-cell-group>
            <van-cell-group inset>
                <van-field
                    style="padding: 10px 0px"
                    v-model="item.postCode"
                    placeholder="请输入邮编"
                    label="邮编"
                >
                </van-field>
            </van-cell-group>
            <van-cell-group inset>
                <van-checkbox class="check-box" v-model="item.defaultStatus">默认</van-checkbox>
            </van-cell-group>
        </div>
        <div class="exit" v-if="hasDel">
            <van-button class="bot" @click="delShow = true">删除</van-button>
            <van-action-sheet
                v-model="delShow"
                :actions="actions"
                cancel-text="取消"
                description="确定要删除职称？"
                close-on-click-action
                style="color: #ff3d3d"
                @select="onSelect"
            />
        </div>
    </div>
</template>

<script>
import { Toast } from "vant";
export default {
    name: "Adeletebe",
    data() {
        return {
            item: {
                unitName: "",
                job: "",
                country: "",
                province: "",
                provinceName: "",
                city: "",
                cityName: "",
                address: "",
                postCode: "",
                defaultStatus: false,
            },
            itemIndexs: "",
            hasDel: false,
            showPicker: false,
            country: 0,
            cascaderValue: "",
            options: [],
            fieldValue: "",
            fieldNames: {
                text: "name",
                value: "code",
            },
            delShow: false,
            actions: [{ name: "删除" }],
        };
    },
    created() {
        this.proLists();
    },
    mounted() {
        console.log(this.$route.query, "this.$route.query");
        if (this.$route.query.item) {
            this.item = JSON.parse(this.$route.query.item);
            this.itemIndexs = Number(this.$route.query.index);
            // 省市回显
            let provinceName = this.item.provinceName;
            let cityName = this.item.cityName;
            if (this.item.provinceName) {
                this.fieldValue = provinceName + "-" + cityName;
            } else if (this.item.country === 1) {
                this.fieldValue = "海外";
            }
            this.country = this.item.country === undefined ? 0 : this.item.country;
            this.hasDel = true;
        }
    },
    methods: {
        to() {
            window.history.go(-1);
        },
        // 省联调
        async proLists() {
            let res = await this.$apis.userServe.proList();
            res.content.provinceList.map((province) => {
                province.children = [{ code: "", name: "" }];
            });
            this.options = res.content.provinceList;
        },
        // 市联调
        async cityLists(value) {
            var index = this.options.findIndex((item) => {
                return item.code == value;
            });
            let res = await this.$apis.userServe.cityList({
                provinceCode: Number(value),
            });
            this.$set(this.options[index], "children", res.content.cityList);
        },
        onChange({ value, selectedOptions, tabIndex }) {
            if (tabIndex === 0) {
                this.cityLists(value);
            }
        },
        // 全部选项选择完毕后，会触发 finish 事件
        onFinish({ selectedOptions }) {
            console.log(this.country, "country");
            if (this.country === 0) {
                console.log(selectedOptions, "selectedOptions");
                this.item.provinceName = selectedOptions[0].name;
                this.item.province = selectedOptions[0].code;
                this.item.cityName = selectedOptions[1].name;
                this.item.city = selectedOptions[1].code;
                this.fieldValue = `${selectedOptions[0].name}-${selectedOptions[1].name}`;
            } else {
                this.item.provinceName = "";
                this.item.province = "";
                this.item.cityName = "";
                this.item.city = "";
                this.fieldValue = "海外";
            }
            this.item.country = this.country;
            this.showPicker = false;
        },
        // 确认删除
        onSelect() {
            const userInfo = JSON.parse(sessionStorage.getItem(`${this.$route.query.sessionName}`));
            userInfo[this.$route.query.key].splice(this.itemIndexs, 1);
            sessionStorage.setItem(`${this.$route.query.sessionName}`, JSON.stringify(userInfo));
            this.to();
        },
        // 点击确定
        toInformation() {
            if (this.item.unitName && this.item.unitName !== "") {
                console.log(this.item, "item");
                const userInfo = JSON.parse(
                    sessionStorage.getItem(`${this.$route.query.sessionName}`)
                );
                if (this.item.defaultStatus) {
                    userInfo[this.$route.query.key].forEach((item) => {
                        item.defaultStatus = false;
                    });
                }

                if (this.$route.query.item) {
                    userInfo[this.$route.query.key][this.itemIndexs] = this.item;
                } else {
                    userInfo[this.$route.query.key].push(this.item);
                }

                sessionStorage.setItem(
                    `${this.$route.query.sessionName}`,
                    JSON.stringify(userInfo)
                );
                this.to();
            } else {
                Toast("机构名称不能为空");
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.Adeletebe {
    width: 100vw;
    min-height: 100vh;
    overflow: hidden;
    background: #f5f5f5;

    .Adeletebe_top {
        height: 44px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
        line-height: 44px;
        align-content: center;
        position: relative;

        .my {
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            background: #fff;
            text-align: center;
        }

        .determine {
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            position: absolute;
            right: 15px;
        }
    }

    .Adeletebe_bottm {
        width: 94%;
        margin: 12px auto;
        background: #fff;
        border-radius: 8px;
    }

    .exit {
        width: 100%;
        height: 44px;
        display: flex;
        justify-content: center;
        align-content: center;
        margin-top: 22px;

        .bot {
            width: 94%;
            height: 44px;
            border-radius: 22px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ff3d3d;
            background: #ffffff;
            border-radius: 22px;
        }
    }
    .check-box {
        // margin: 10px 0;
        height: 44px;
    }
}
::v-deep .tab-box {
    flex: none;
    padding: 0 25px;
    font-size: 16px;
    // width: 50px;
}
::v-deep .van-tabs__line {
    background-color: #4a79f1;
    width: 20px;
}
</style>
